import { PageSection } from 'components';
import {
    Content,
    ContentTitle,
    SkewWrapper,
    Switch,
    SwitchItem,
    TitleWrapper,
    Wrapper,
} from 'containers/pages/profession-item/components/conditions/styled';
import { useCourse } from 'contexts/course.context';
import DOMPurify from 'dompurify';
import { Button } from 'kl-b2c-ui-kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConditionCategory, CourseTemplate } from 'types/enums';
import { courseRedirectResolver } from 'utils';
import { langMapper } from 'utils/lang-convert';
import { SectionTitle } from '../../styled';
import { ButtonContainer, Footer, FooterTitle, ListWrapper } from './styled';

interface IProps {
    onOpenRegisterModal: () => void;
    isXTraining?: boolean;
}

const sectionConfig = {
    CWrap: {
        css: {},
    },
    ContentArea: {
        css: {
            display: 'block',
            padding: '0 20px 0',
            overflow: 'hidden',
        },
    },
};

export const Program: FC<IProps> = ({ onOpenRegisterModal, isXTraining }) => {
    const { t, i18n } = useTranslation('pages/courses');
    const { course } = useCourse();
    const langDomain = langMapper[i18n.language];

    const [conditionCategory, setConditionCategory] =
        useState<ConditionCategory>(ConditionCategory.Knowledge);

    if (!course) {
        return null;
    }

    return (
        <SkewWrapper>
            <PageSection config={sectionConfig}>
                <Wrapper
                    styles={{
                        backgroundImage: 'none',
                        background: '#F4F7FA',
                        position: 'relative',
                        zIndex: 5,
                    }}>
                    <TitleWrapper>
                        <SectionTitle>{t('program')}</SectionTitle>
                        <Switch>
                            <SwitchItem
                                onClick={() =>
                                    setConditionCategory(
                                        ConditionCategory.Knowledge
                                    )
                                }
                                isActive={
                                    conditionCategory ===
                                    ConditionCategory.Knowledge
                                }>
                                {t('topic')}
                            </SwitchItem>
                            <SwitchItem
                                onClick={() =>
                                    setConditionCategory(
                                        ConditionCategory.Skill
                                    )
                                }
                                isActive={
                                    conditionCategory ===
                                    ConditionCategory.Skill
                                }>
                                {t('practicePart')}
                            </SwitchItem>
                        </Switch>
                    </TitleWrapper>

                    <Content>
                        <ContentTitle styles={{ color: '#1D1D1B' }}>
                            {conditionCategory === ConditionCategory.Knowledge
                                ? t('topic')
                                : t('practicePart')}
                        </ContentTitle>
                        <ListWrapper
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                    conditionCategory ===
                                        ConditionCategory.Knowledge
                                        ? course.topic ?? ''
                                        : course.practicePart ?? ''
                                ),
                            }}
                        />
                    </Content>

                    {(course?.template === CourseTemplate.Awareness ||
                        course?.additionalProgram?.fileLink) && (
                        <Footer>
                            <FooterTitle>{t('course-more')}</FooterTitle>
                            <ButtonContainer>
                                <Button
                                    onClick={() => {
                                        if (
                                            course?.template ===
                                            CourseTemplate.Awareness
                                        ) {
                                            return window.open(
                                                course.buyLink,
                                                '_blank',
                                                'noopener,noreferrer'
                                            );
                                        }
                                        return window.open(
                                            course?.additionalProgram?.fileLink,
                                            '_blank',
                                            'noopener,noreferrer'
                                        );
                                    }}
                                    variant={'outlined'}
                                    color={'primary'}
                                    size={'large'}>
                                    {t('more')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        if (isXTraining) {
                                            window.open(course.demoLink);
                                            return;
                                        }
                                        courseRedirectResolver(
                                            course,
                                            langDomain,
                                            onOpenRegisterModal
                                        );
                                    }}
                                    variant={'contained'}
                                    color={'primary'}
                                    size={'large'}>
                                    {course.template === CourseTemplate.Product
                                        ? t('pages/courses:find-a-provider')
                                        : isXTraining
                                        ? t('demo-request')
                                        : t('pages/courses:request-button')}
                                </Button>
                            </ButtonContainer>
                        </Footer>
                    )}
                </Wrapper>
            </PageSection>
        </SkewWrapper>
    );
};
